import * as Yup from "yup";

import {validationMessages} from "../../form/utils/validation_messages";

export const registerFormValidationSchema = Yup.object().shape({
    email: Yup.string().email().required(),
    password: Yup.string().required(),
    marketing_email: Yup.boolean().required().oneOf([true], validationMessages.required),
    marketing_sms: Yup.boolean()
});
import * as Yup from "yup";

import {validationMessages} from "../../form/utils/validation_messages";

export const registerFormValidationSchema = Yup.object().shape({
    email: Yup.string().email().required(),
    password: Yup.string().required(),
    marketing_email: Yup.boolean().required().oneOf([true], validationMessages.required),
    marketing_sms: Yup.boolean()
});
